import React from "react";
import StyledDrawerItem from "./styles";

import { useNavigate } from "react-router-dom";

const DrawerItem = ({
  onClick,
  img,
  Icon,
  link,
  active,
  leftComponent,
  rightComponent,
  open,
}) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    if (onClick) onClick();
    if (link) navigate(link);
  };

  const finalClassName = `item-content-container ${
    active ? "item-content-container--active" : ""
  }`;

  return (
    <StyledDrawerItem onClick={onClickHandler}>
      <div className={finalClassName}>
        {rightComponent && (
          <div
            className={`right-component right-component--${open ? "open" : ""}`}
          >
            <div className="right-component-cont">{rightComponent}</div>
          </div>
        )}

        <div className="icon-container">
          {img && (
            <div className="image-container">
              <img src={img} alt={link || "image"} />
            </div>
          )}

          {Icon && (
            <Icon
              opacity={0.8}
              fontSize="small"
              sx={{
                width: 25,
                height: 25,
              }}
            />
          )}
        </div>

        {leftComponent && (
          <div
            className={`left-component left-component--${open ? "open" : ""}`}
          >
            <div className="left-component-cont">{leftComponent}</div>
          </div>
        )}
      </div>
    </StyledDrawerItem>
  );
};

export default DrawerItem;
